import classNames from "classnames";

import DeleteFavouriteLockerIcon from "@components/Icons/Lockers/DeleteFavouriteLockerIcon";
import SaveFavouriteLockerIcon from "@components/Icons/Lockers/SaveFavouriteLockerIcon";

const LockerCardSaveOrDeleteAction = ({
  onSaveOrDeleteFavouriteLocker,
  isFavourite = false,
  isDisabled = false,
}) => (
  <div
    className={classNames("flex items-center gap-[6px]", {
      "cursor-pointer": !isDisabled,
      "cursor-not-allowed text-[#767676] opacity-60": isDisabled,
    })}
    onClick={isDisabled ? undefined : onSaveOrDeleteFavouriteLocker}
  >
    {isFavourite ? <DeleteFavouriteLockerIcon /> : <SaveFavouriteLockerIcon />}

    <div>
      {isFavourite ? "Sterge ca punct favorit" : "Salveaza ca punct favorit"}
    </div>
  </div>
);

export default LockerCardSaveOrDeleteAction;
